
const SAVE_DATUM = 'save_datum'
const SAVE_REVISE = 'save_revise'
const SAVE_NUM = 'save_num'
const SAVE_FILEOBJ = 'save_fileobj'
const BORROW_DETAILS = 'borrow_details'
const SAVE_ROSTER_MSG = 'saveRosterMsg'

const state = {
  saveDatumData: {
    "applyFundMaterial": null,
    "applyFundMachine": null,
    "applyFundOther": null,
    "approveUserId": null,
    "approveUserId": null,
    "payUserName": null,
    "approveComment": ''
  },
  reviseEd: false,
  zwNum: 0,
  fileobj:{},
  borrowDetails: {
    status: 1,
    table1: [],
    table2: []
  },
  rosterMsg: []
}
const getters = {
  saveDatumData: (state) => state.saveDatumData,
  reviseEd: (state) => state.reviseEd,
  zwNum: (state) => state.zwNum,
  fileobj: (state) => state.fileobj,
  borrowDetails: (state) => state.borrowDetails,
  rosterMsg: (state) => state.rosterMsg,
}
const mutations = {
  [SAVE_DATUM](state, parame) {
    state.saveDatumData = parame
  },
  [SAVE_REVISE](state, parame) {
    state.reviseEd = parame
  },
  [SAVE_NUM](state, parame) {
    state.zwNum = parame
  },
  [SAVE_FILEOBJ](state, parame) {
    state.fileobj = parame
  },
  [BORROW_DETAILS](state, parame) {
    if(parame instanceof Array) {
      if(parame[1] == 1) {
        for(let k=0;k<parame[0].length;k++) {
          state.borrowDetails.table1.push(parame[0][k])
        }
      } else if(parame[1] == 2){
        for(let k=0;k<parame[0].length;k++) {
          state.borrowDetails.table2.push(parame[0][k])
        }
      } else {
        state.borrowDetails.table1 = []
        state.borrowDetails.table2 = []
      }
    } else {
      if(!parame.hasOwnProperty('table1')) {
        parame.table1 = []
        parame.table2 = []
      }
      state.borrowDetails = parame
      
    }
  },
  [SAVE_ROSTER_MSG](state, parame) {
    state.rosterMsg = parame
  }
}
const actions = {
  saveDatum({commit}, parame) {
    commit(SAVE_DATUM, parame)
  },
  isRevise({commit}, parame) {
    commit(SAVE_REVISE, parame)
  },
  saveNum({commit}, parame) {
    commit(SAVE_NUM, parame)
  },
  saveFileobj({commit}, parame) {
    commit(SAVE_FILEOBJ, parame)
  },
  borrowDetailsMessage({commit}, parame) {
    commit(BORROW_DETAILS, parame)
  },
  saveRosterMsg({commit}, parame) {
    commit(SAVE_ROSTER_MSG, parame)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/capital/details.js